export const getIsSubmitting = (state) => state.ui.checkout.submitting || false;

export const getCheckoutOrderUUID = (state) => state.ui.checkout.orderUUID;

export const getCheckoutUploadingPaystub = (state) =>
    state.ui.checkout.uploadingPaystub || false;

const getCheckoutErrors = (state) => state.ui.checkout.errors || {};

export const getPaystubErrors = (state) =>
    getCheckoutErrors(state).paystub || {};
